import { Button } from '~/components/ui/Button';
import { WrapperWidget } from '@agentselly/ui';
import { useTranslate } from '@tolgee/react';

interface Props {
  readonly title: string;
  readonly adViewsTotal: string;
  readonly interestedBuyersTotal: string;
  readonly bookedVisitsTotal: string;
  readonly offersTotal: string;
  readonly link: string;
}

export function CockpitSummaryWidget(props: Props) {
  const { t } = useTranslate();

  return (
    <WrapperWidget title={t(props.title)}>
      <div className="h-full flex flex-col gap-y-6">
        <div className="flex flex-wrap gap-x-8 gap-y-2 flex-grow my-4 md:my-12">
          <div className="flex flex-col">
            <div className="text-2xl font-bold tabular-nums">
              {props.adViewsTotal}
            </div>
            <div className="text-sm md:text-base">
              {t('cockpit_ad_views_widget_text')}
            </div>
          </div>
          <div className="flex flex-col">
            <div className="text-2xl font-bold tabular-nums">
              {props.interestedBuyersTotal}
            </div>
            <div className="text-sm md:text-base">
              {t('cockpit_interested_buyers_widget_text')}
            </div>
          </div>
          <div className="flex flex-col">
            <div className="text-2xl font-bold tabular-nums">
              {props.bookedVisitsTotal}
            </div>
            <div className="text-sm md:text-base">
              {t('cockpit_booked_visits_widget_text')}
            </div>
          </div>
          <div className="flex flex-col">
            <div className="text-2xl font-bold tabular-nums">
              {props.offersTotal}
            </div>
            <div className="text-sm md:text-base">
              {t('cockpit_offers_widget_text')}
            </div>
          </div>
        </div>
        <a
          href={props.link}
          className="self-start"
        >
          <Button
            primary
            showArrow
          >
            {t('cockpit_summary_widget_button_text')}
          </Button>
        </a>
      </div>
    </WrapperWidget>
  );
}
